import { LocalStorageNamespace } from "@utils";

type TLocalStoragePublicKeys = "showAccessibleWordCloud";

const CPublicNamespace = new LocalStorageNamespace<TLocalStoragePublicKeys>(
  "public",
);

const PublicLocalStorage = {
  /**
   * - tracks the state of the accessibility view for the word cloud when survey results are displayed
   * - if true a table view is displayed instead of the word cloud
   */
  showAccessibleWordCloud: CPublicNamespace.createKeyHandler(
    "showAccessibleWordCloud",
    false,
  ),
} as const;

export default function usePublicLocalStorage() {
  return PublicLocalStorage;
}
